import { BookSectionsDocument } from "@/generated/graphql";
import { useQuery } from "@apollo/client/react";

export interface BookSection {
  name: string;
  lessonCount: number;
  totalLessons: number;
  passageCount: number;
  dialogueCount: number;
  sampleLines: string[];
  sampleLessonId: string | null;
  sampleLesson: string | null;
}

/**
 * The sections printed across a book, for scoping a generator section to one of them. Needs only a
 * series: a level or component narrows the coverage counts to the lessons a batch will actually run,
 * and a lesson makes its own lines the sample each section shows.
 */
export function useBookSections(
  scope: {
    seriesSlug: string | null;
    levelId: string | null;
    componentId: string | null;
  },
  bookLessonId: string | null = null
) {
  const { data, loading } = useQuery(BookSectionsDocument, {
    variables: {
      seriesSlug: scope.seriesSlug ?? "",
      levelId: scope.levelId,
      componentId: scope.componentId,
      bookLessonId,
    },
    skip: !scope.seriesSlug,
    fetchPolicy: "cache-first",
  });

  return { sections: (data?.bookSections ?? []) as BookSection[], loading };
}
